import { Button, Cell, Grid, HFlow, Icon, Tooltip } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { Box } from 'components/Box'
import {
  CheckboxField,
  EquipeSelectField,
  Form,
  FormRenderProps,
  SubmitButton,
  UnidadeSaudeSelectField,
} from 'components/form'
import { RecordStringSelectField } from 'components/form/final-form/RecordStringSelectField/RecordStringSelectField'
import { css } from 'emotion'
import { metaPath } from 'util/metaPath'

import {
  AtividadeColetivaGruposFilterFormModel,
  AtividadeColetivaGruposFilterPopperFormModel,
  atividadeColetivaTipoGrupoRecord,
} from '../grupos/model-atividadeColetivaGrupos'

const isCleanFilter = (filter: AtividadeColetivaGruposFilterFormModel) => {
  return (
    !filter.nomeGrupo &&
    !filter.isSomenteRegistrosProprios &&
    !filter.unidadesSaude &&
    !filter.equipes &&
    !filter.tipoGrupo &&
    !filter.showOnlyInativos
  )
}

const path = metaPath<AtividadeColetivaGruposFilterFormModel>()

interface AtividadeColetivaGruposFilterPopperFormProps {
  readonly filter: AtividadeColetivaGruposFilterFormModel
  readonly onChangeFilter: (values: AtividadeColetivaGruposFilterFormModel) => void
  readonly onClose: () => void
}

export function AtividadeColetivaGruposFilterPopperForm(props: AtividadeColetivaGruposFilterPopperFormProps) {
  const { filter, onChangeFilter, onClose } = props
  const { acesso } = useAcessoLotacaoOrEstagio()

  const municipio = acesso?.municipio

  const handleClear = () => {
    onChangeFilter({
      isSomenteRegistrosProprios: false,
      pageParams: filter.pageParams,
    })
  }

  const handleSubmit = (values: AtividadeColetivaGruposFilterFormModel) => {
    onChangeFilter({ ...filter, ...values })
    onClose()
  }

  const renderForm = (formProps: FormRenderProps<AtividadeColetivaGruposFilterPopperFormModel>) => {
    return (
      <Box style={styles.box}>
        <Grid>
          <Cell size={12}>
            <UnidadeSaudeSelectField name={path.unidadesSaude} label='Unidade de saúde' multiple />
          </Cell>
          <Cell size={12}>
            <EquipeSelectField
              name={path.equipes}
              label='Equipe'
              localidadeId={municipio.id}
              multiple
              showSemEquipeOption
            />
          </Cell>
          <Cell size={12}>
            <RecordStringSelectField
              name={path.tipoGrupo}
              label='Tipo de grupo'
              record={atividadeColetivaTipoGrupoRecord}
            />
          </Cell>
          <Cell size={12}>
            <CheckboxField name={path.showOnlyInativos} label='Ver somente grupos inativos' />
          </Cell>
          <Cell size={12}>
            <HFlow justifyContent='center'>
              <Button onClick={onClose} size='small' skin='outline' kind='normal'>
                Fechar
              </Button>

              <Tooltip text='Redefinir filtros para o padrão'>
                <Button kind='normal' size='small' onClick={handleClear} disabled={isCleanFilter(filter)}>
                  <Icon style={styles.redoIcon} icon='redo' />
                  Voltar para padrão
                </Button>
              </Tooltip>

              <SubmitButton size='small' handleSubmit={formProps.handleSubmit}>
                Filtrar
              </SubmitButton>
            </HFlow>
          </Cell>
        </Grid>
      </Box>
    )
  }

  return (
    <Form<AtividadeColetivaGruposFilterPopperFormModel>
      initialValues={filter}
      render={renderForm}
      onSubmit={handleSubmit}
    />
  )
}

const styles = {
  box: css`
    width: 21.75rem;
    margin-top: 1rem;
  `,
  redoIcon: css`
    padding-right: 0.5rem;
  `,
}
